<template>
<div class="pharmacies">

	<!-- page header -->
  <page-heading :show="true" pageTitle="HEADER_PHARMACIES"></page-heading>

  <!-- show loading indicator -->
  <loading-indicator :loading="isLoading"></loading-indicator>

	<div class="columns" v-if="!isLoading">

		<div class="col-main">

      <!-- extRefColName="PHARMACY-TABLE_HEADING-BTNR" -->
      <pharmacies
        ref="pharmacies"
        apiURL="site/apokat"
        routeDetailName="catalogPharmacyDetail"
        showSearch="true"
        :activeFilters="['hasChanged', 'onlineReady', 'packages', 'status']"
        :tblColumns="['extRef', 'name', 'location', 'quantity', 'postDelivery', 'package', 'coupons']"
        :tblSortColumns="['extRef', 'name', 'location']"
        :tblOptions="{ perPage: 25 }">
      </pharmacies>

		</div>

		<div class="col-aside">

      <affix :offset="50">

        <div class="sidebox kpi" v-if="stats != null">

            <div class="item is-clearfix" v-for="(value, key, index) in stats">
                <lang :labelKey="'KPI_'+key" class="label is-pulled-left"></lang>
                <span class="value">{{ value.value }}</span>
                <span :class="[value.percentage >= 0 ? 'green' : 'red', 'percentage']">
                    <template v-if="value.percentage >= 0">+</template>
                    <template v-else>-</template>{{ value.percentage }}%
                </span>
            </div>

        </div>

        <div class="sidebox multiple" v-if="userRole != 'Kundenbetreuer'">
          <export-button export="pharmacies" btnTitle="SITE_BTN_EXP_PHARMACIES" modalTitle="MODAL_HEADER-EXPORT_PHARMACIES" :title="$t('MODAL_HEADER-EXPORT_PHARMACIES')"></export-button>
          <export-button export="pharmaciesCustomizations" btnTitle="SITE_BTN_EXP_CUSTOMIZATIONS" modalTitle="MODAL_HEADER-EXPORT_CUSTOMIZATIONS" :title="$t('MODAL_HEADER-EXPORT_CUSTOMIZATIONS')"></export-button>
        </div>

        <div v-else>
            <export-button export="pharmacies" btnTitle="SITE_BTN_EXP_PHARMACIES" modalTitle="MODAL_HEADER-EXPORT_PHARMACIES" :title="$t('MODAL_HEADER-EXPORT_PHARMACIES')"></export-button>
        </div>


        <upload-box class="sidebox buttonDropzone"
            :url= "$config.api + 'fileProcessing/upload?preset=sitePerformance'"
            :thumbnailWidth="145"
            :thumbnailHeight="67"
            :language="{dictDefaultMessage: 'hochladen'}" v-if="userRole != 'Kundenbetreuer'">
        </upload-box>

        <custom-button name="CATALOG-BTN-LAST_CHANGES" type="dark" icon="icon-ak-history" :title="$t('CATALOG-BTN-LAST_CHANGES')" v-if="userRole == 'Administrator'" @click.native="goHistory"></custom-button>

        <div class="sidebox" v-if="userRole == 'Administrator' && ['tamara', 'niloo', 'andreas', 'matthias'].indexOf(this.activeUser.username) > -1">
          <div class="heading"><lang labelKey='SITE-REMINDERS'></lang></div>

          <custom-button name="SITE-BTN-REQUEST_FEEDBACK" type="dark" icon="icon-ak-send" :isDisabled="reminderStatus.feedbackRequestCount == 0" @click.native="reminder('sendFeedbackRequest', reminderStatus.feedbackRequestCount)">
              <template slot="next-to-icon" v-if="reminderStatus.feedbackRequestCount > 0">{{ reminderStatus.feedbackRequestCount }}</template>
              <small v-if="reminderStatus.lastFeedbackRequestSendDate != null">letzte Sendung: {{ formatDate2(reminderStatus.lastFeedbackRequestSendDate) }}</small>
          </custom-button>

          <custom-button name="SITE-BTN-REMINDER_DATA" type="dark" icon="icon-ak-send" :isDisabled="reminderStatus.feedbackReminderCount == 0" @click.native="reminder('sendFeedbackReminder', reminderStatus.feedbackReminderCount)">
              <template slot="next-to-icon" v-if="reminderStatus.feedbackReminderCount > 0"> ({{ reminderStatus.feedbackReminderCount }})</template>
              <small v-if="reminderStatus.lastFeedbackReminderSendDate != null">zuletzt gesendet: {{ formatDate2(reminderStatus.lastFeedbackReminderSendDate) }}</small>
          </custom-button>

          <custom-button name="SITE-BTN-REMINDER_PRINT" type="dark" icon="icon-ak-send" :isDisabled="reminderStatus.printApprovalReminderCount == 0" @click.native="reminder('sendPrintApprovalReminder', reminderStatus.printApprovalReminderCount)">
              <template slot="next-to-icon" v-if="reminderStatus.printApprovalReminderCount > 0"> ({{ reminderStatus.printApprovalReminderCount }})</template>
              <small v-if="reminderStatus.lastPrintApprovalReminderSendDate != null">zuletzt gesendet: {{ formatDate2(reminderStatus.lastPrintApprovalReminderSendDate) }}</small>
          </custom-button>

        </div>


      </affix>

		</div>

	</div>

    <modal
      :title="modal.title"
      :width="modal.width"
      :is-show="showModal"
      transition="fade"
      :backdrop-closable="false"
      @close="closeModal()"
      :class="modal.class">

        <template v-if="isCustomizationPreview">

          <div v-if="activePage != null" class="previewWrappers" :key="activePage">
            <div v-for="(value, key) in activePage.customizationPreviews" :class="[key, 'previewWrapper lazy-img-fadein']" v-lazy:background-image="loadCustomizationImage(value)" :key="key">
              <div class="title"><lang :labelKey="'SITE-MODAL-MUTATIONS_TITLE-'+key"></lang></div>
            </div>
          </div>

          <div slot="footer">
            <a class="button" @click="closeModal">{{ this.modal.txtCancel }}</a>
          </div>

        </template>

        <template v-else>

            <template v-if="modal.isSending && progressStatus != null && progressStatus.status != 'Finished'">

                <template v-if="progressStatus.status == 'Error'">

                    <div class="has-text-centered" style="margin-bottom: 5px;">
                        PROBLEM ...:<br />
                        <span style="color: red; ">{{ progressStatus.log }}</span>
                    </div>

                </template>

                <template v-else>

                    <div class="has-text-centered" style="margin-bottom: 5px;">{{ progressStatus.log }}</div>
                    <progress-bar :percent="progressStatus.progress" :showinfo="false" :striped="true" :animated="true" size="large"></progress-bar>

                </template>

            </template>

            <template v-else-if="progressStatus != null && progressStatus.status == 'Finished'">

                <alert type="success">Die Reminder wurden erfolgreich verschickt!</alert>

            </template>

            <template v-else>

                <div class="has-text-centered">
                    <!-- <lang :labelKey="'SITE-MODAL_TEXT-'+modal.type"></lang> -->
                    {{ $t(('SITE-MODAL_TEXT-'+modal.type).toUpperCase()).replace('{RECIPIENT_COUNT}', modal.count) }}
                </div>

            </template>


            <div slot="footer">

                <template v-if="!isSending && progressStatus != null && progressStatus.status == 'Finished'">

                    <a class="button" @click="closeModal()">schließen</a>

                </template>

                <template v-else>

                    <a class="button" @click="closeModal">{{ modal.txtCancel }}</a>
                    <a :class="['button is-primary', { 'is-loading': modal.isSending }]" @click="reminderSend()">
                        <span class="icon is-small">
                            <i class="icon-ak-send" aria-hidden="true"></i>
                        </span>
                        {{ modal.txtSubmit }}
                    </a>

                </template>

            </div>

        </template>

    </modal>

</div>

</template>

<script>
import Vue from 'vue';
import { ClientTable, Event } from 'vue-tables-2';
Vue.use(ClientTable, {}, false, 'bulma');

import exportButton from '../utils/exportButton';
import uploadBox from '../utils/uploadBox';
import statusDropdown from '../utils/incl-statusDropdown'
import pharmacies from '../utils/incl-pharmacies';

export default {

	name: 'sites',

    components: {
		exportButton,
      uploadBox,
      statusDropdown,
      pharmacies
	},

	data() {
		var self = this;
		return {
			query: '',
			isLoading: false,
      isFilterActive: false,
      filterMutationOptions: [],
      mutations: '',
      stats: null,
      reminderStatus: null,

      isCustomizationPreview: false,
      activePage: null,

      showModal: false,
      modal: {
        title: "",
        width: 520,
        txtCancel: 'abbrechen',
        txtSubmit: 'senden',
        count: null,
        isSending: false,
        class: ""
      },

      progressStatus: null,
      refreshIntervalId: null,

			table: {

				tblData: [],

				tblColumns: ['extRef', 'name', 'city', 'quantity', 'postDelivery', 'package', 'coupons'],

        tblOptions: {
					uniqueKey: 'extRef',
					saveState: true,
					perPage: 25,
					orderBy: {
						ascending: false,
						column: 'name'
					},
        sortIcon: {
            base:'fa',
            up:'fa-sort-up',
            down:'fa-sort-down',
            is:'fa-sort'
        },

        // custom table headings - make them clickable for language Setting
				headings: {

					extRef(h) {
						return <lang labelKey="SITE_TBL_HEADER-EXTREF"></lang>
					},
					name(h) {
						return <lang labelKey="SITE_TBL_HEADER-NAME"></lang>
					},
					zipcode(h) {
						return <lang labelKey="SITE_TBL_HEADER-ZIP"></lang>
					},
					city(h) {
						return <lang labelKey="SITE_TBL_HEADER-CITY"></lang>
					},
					package(h) {
						return <lang labelKey="SITE_TBL_HEADER-PACKAGE"></lang>
					},
					quantity(h) {
						return <lang labelKey="SITE_TBL_HEADER-QTY"></lang>
					},
					postDelivery(h) {
						return <div><lang labelKey="SITE_TBL_HEADER-POST_DELIVERY"></lang><br /><span class="is-small">Datei/PLZ</span></div>
					},
					coupons(h) {
						return <lang labelKey="SITE_TBL_HEADER-COUPONS"></lang>
					},
				},

        sortable: ['extRef', 'name', 'city', 'quantity'],
        filterable: false,

        // customizations for table columns
				templates: {

					extRef: function(h, row) {
            return row.site.extRef;
					},

					name: function(h, row) {
            return row.site.name;
					},

					city: function(h, row) {
            return row.site.zipcode + ' ' + row.site.city;
					},

					quantity: function(h, row) {
						return row.quantity != 0
							? row.quantity + '+' + row.rebateInKind + '=' + (parseInt(row.quantity) + parseInt(row.rebateInKind))
							: '';
					},

					postDelivery: function(h, row) {

						if(row.shipmentRecipientListQty > 0 || row.shipmentAreaQty > 0)
						{
							return (row.shipmentRecipientListQty != null && row.shipmentRecipientListQty != "" ? row.shipmentRecipientListQty : '-') + " / " + (row.shipmentAreaQty != null && row.shipmentAreaQty != "" ? row.shipmentAreaQty : '-');
						}
						else
						{
							return "";
						}
					},

					coupons: function(h, row) {
						if(
							(row.promotionMaterialPackageQty != 0 && row.promotionMaterialPackageQty != null) ||
							(row.couponBoxQty != 0 && row.couponBoxQty != null) ||
							(row.couponSetQty != 0 && row.couponSetQty != null)
                          ) {
					 		return (row.promotionMaterialPackageQty != 0 ? row.promotionMaterialPackageQty : '-') + ' / ' + (row.couponBoxQty != null ? row.couponBoxQty : '-') + ' / ' + (row.couponSetQty != 0 ? row.couponSetQty : '-');
						}
					}

        },

				texts: {
          first:'Anfang',
          last:'Ende',
					filter: 'Filter Ergebnisse:',
					filterPlaceholder: 'Suche',
					limit: 'Einträge pro Seite',
					noResults: 'keine passenden Einträge gefunden',
					count: '{from} bis {to} von {count} Einträgen|{count} Einträge|ein Eintrag'
				},

				pagination: {
          dropdown: false,
          chunk: 5,
          edge: false
        },

        skin: 'table is-striped is-hoverable is-fullwidth',

        // custom filter functions
				customFilters: [
					{
						name: 'search',
						callback: function(row, string) {

              if(string == "" || string == null) {
                return true;
              }

              var string = string.toLowerCase();

              return row.site.name.toLowerCase().indexOf(string) >= 0
                  || row.site.city.toLowerCase().indexOf(string) >= 0
                  || row.site.extRef.indexOf(string) >= 0
                  || row.site.zipcode.toLowerCase().indexOf(string) >= 0
                  || row.site.contactPerson != null && row.site.contactPerson.fullName.toLowerCase().indexOf(string) >= 0;

						}
					},


          {
						name: 'changedPharmacies',
						callback: function(row, showChanged) {
              return row.hasChanged == showChanged;
						}
					},

					{
							name: 'filterCatalog',
							callback: function(row, payload) {

                let filterStatus = payload.filterStatus ? payload.filterStatus.name : null;
                let filterMutation = payload.filterMutation ? payload.filterMutation.value : null;

                // reset
                if(filterStatus == null && filterMutation == null) {
                    return true;
                }

                // mutation only
                else if(filterMutation != null && filterStatus == null) {

                    switch(filterMutation) {
    									case "1":
    										return row.package == 1 && row.voucherPackage == 10;
    									case "1GS":
    										return row.package == 1 && row.voucherPackage > 10;
    									case "2":
    										return row.package == 2 && row.voucherPackage == 10;
    									case "2GS":
    										return row.package == 2 && row.voucherPackage > 10;
    									case "3":
    										return row.package == 3 && row.voucherPackage == 10;
    									case "3GS":
    										return row.package == 3 && row.voucherPackage > 10;
                      case "4":
                          return row.hasCustomDesign == true && row.voucherPackage == 10;
                      case "4GS":
                          return row.hasCustomDesign == true && row.voucherPackage > 10;
    									case "all":
    										return row.package > 0;
                      case "onlineReady":
                          return row.onlineReady === true;
    									default:
    										return true;

                      }
                  }

                  // status only
                  else if(filterStatus != null && filterMutation == null) {
                    return row.status == self.siteCatalogStatus[filterStatus].id;
                  }

                  // mutation and status
                  else if(filterStatus != null && filterMutation != null) {

    								switch(filterMutation) {
    									case "1":
    										return row.status == self.siteCatalogStatus[filterStatus].id && row.package == 1 && row.voucherPackage == 10;
    									case "1GS":
    										return row.status == self.siteCatalogStatus[filterStatus].id &&row.package == 1 && row.voucherPackage > 10;
    									case "2":
    										return row.status == self.siteCatalogStatus[filterStatus].id &&row.package == 2 && row.voucherPackage == 10;
    									case "2GS":
    										return row.status == self.siteCatalogStatus[filterStatus].id &&row.package == 2 && row.voucherPackage > 10;
    									case "3":
    										return row.status == self.siteCatalogStatus[filterStatus].id &&row.package == 3 && row.voucherPackage == 10;
    									case "3GS":
    										return row.status == self.siteCatalogStatus[filterStatus].id &&row.package == 3 && row.voucherPackage > 10;
    									case "all":
    										return row.status == self.siteCatalogStatus[filterStatus].id && row.package > 0;
                      case "onlineReady":
                          return row.status == self.siteCatalogStatus[filterStatus].id && row.onlineReady === true;
    									default:
    										return true;

                      }

                  }

							}
						}
					],

          initFilters: {

            filterCatalog: {
              filterStatus: self.$store.getters.getPharmaciesFilter('filterStatus'),
              filterMutation: self.$store.getters.getPharmaciesFilter('filterMutation')
            },
            search: self.$store.getters.getPharmaciesFilter('searchString'),
            changedPharmacies: self.$store.getters.getPharmaciesFilter('filterChangedPharmacies'),

          },

          // custom sorting functions
					customSorting: {

						name: function(ascending) {
							return function (a, b) {
		            return self.sort(a.site.name, b.site.name, ascending);
							}
						},

						city: function(ascending) {
							return function (a, b) {
                return self.sort(a.site.zipcode, b.site.zipcode, ascending);
							}
            },

						extRef: function(ascending) {
							return function (a, b) {
                return self.sort(a.site.extRef, b.site.extRef, ascending);
							}
						},

            quantity: function(ascending) {
              return function (a, b) {
                return self.sort(parseInt(a.quantity)+parseInt(a.rebateInKind), parseInt(b.quantity)+parseInt(b.rebateInKind), ascending);
              }
            }

					},

					rowClassCallback: function(row) {

            if(row.status == null) {
							return '';
						}

            return "status " + self.getsiteCatalogStatusNameById(row.status);

					}

				}
			},

			tblFilters: {
				"filterVauchers": false
			}

		}

	},

	created() {

    this.fetchData();

    // set our reset filter button to inacative/active in case any of the above filters is not null
    this.isFilterActive = !this.filterStatusChanged;

    this.filterMutationOptions = [
      {
          name: this.$t("ALL"),
          value: 'all'
      },
      {
          name: this.$t("U1_U4"),
          value: "1"
      },
      {
          name: this.$t("U1_U4-GS"),
          value: "1GS"
      },
      {
          name: this.$t("U1_U4_U2"),
          value: "2"
      },
      {
          name: this.$t("U1_U4_U2-GS"),
          value: "2GS"
      },
      {
          name: this.$t("U1_U4_U2_US"),
          value: "3"
      },
      {
          name: this.$t("U1_U4_U2_US-GS"),
          value: "3GS"
      },
      {
          name: this.$t("CUSTOM_DESIGN"),
          value: "4"
      },
      {
          name: this.$t("CUSTOM_DESIGN-GS"),
          value: "4GS"
      },

    ]

    if(this.can('ADVANCED.ENABLE_ONLINE_NOT_READY_SITES_FILTER')) {
        this.filterMutationOptions.unshift({ name: this.$t("ONLINE_READY"), value: 'onlineReady' });
    }


	},

	mounted() {

        // handle click events on table rows
        Event.$on('vue-tables.tblPharmacies.row-click', function (data) {

            // check if the user wants to open the pharmacy in a new tab
            if(data.event.ctrlKey == true || data.event.altKey == true) {

                let protocol = location.protocol;
                let slashes = protocol.concat("//");
                let host = slashes.concat(window.location.hostname);
                let url = "";

                if(window.location.hostname == "localhost") {
                    url = host + ':' + window.location.port + '/apotheken/apotheke-' + data.row.site.id;
                } else {
                    url = '/katalog/apotheken/apotheke-' + data.row.site.id;
                    // url = this.$config.cdn + '/apotheken/apotheke-' + data.row.site.id;
                }

                let win = window.open(url, '_blank');

            } else {
              console.log(data.row.site.id);

              // this.$router.push('/apotheken/apotheke-' + data.row.site.id);
              this.$router.push({ name: 'catalogPharmacyDetail', params: { siteID: data.row.site.id}});

            }

		}.bind(this));


	},

	updated() {

	},

  beforeDestroy() {

      Event.$off('vue-tables.tblPharmacies.row-click');

  },

	computed: {

		voucherPackages() {
      return this.$store.getters.getTermsByTaxonomy('VOUCHER_PACKAGES');
    },

    voucherStatus() {
      return this.$store.getters.getTermsByTaxonomy('VOUCHER_STATUS');
    },

    siteCatalogStatus() {
      return this.$store.getters.getTermsByTaxonomy('SITE_CATALOG_STATUS');
    },

    siteCatalogCustomizations() {
      return this.$store.getters.getTermsByTaxonomy('SITE_CATALOG_CUSTOMIZATIONS');
    },

    siteCatalogCustomizationsStatus() {
      return this.$store.getters.getTermsByTaxonomy('SITE_CATALOG_CUSTOMIZATION_STATUS');
    },

    // computed property returns true if any of the filters have a value other than null
    filterStatusChanged() {

      return (this.filterMutation == null && this.filterStatus == null
          && (this.filterChangedPharmacies == null || this.filterChangedPharmacies === false)
          && (this.searchString == null || this.searchString == ''));

    },

    searchString: {

        get() {
            return this.$store.getters.getPharmaciesFilter('searchString');
        },

        set(val) {

            // save new values in our store
            this.$store.commit('setPharmaciesFilter', { type: 'searchString', value: val });

            // emit new values to our table component
            Event.$emit('vue-tables.tblPharmacies.filter::search', val);

        }

    },


    filterMutation: {

        get() {
            return this.$store.getters.getPharmaciesFilter('filterMutation');
        },

        set(val) {

            // save new values in our store
            this.$store.commit('setPharmaciesFilter', { type: 'filterMutation', value: val });

            // emit new values to our table component
            Event.$emit('vue-tables.tblPharmacies.filter::filterCatalog', {
                filterStatus: this.filterStatus,
                filterMutation: val
            });

        }
    },

    filterStatus: {

        get() {
            return this.$store.getters.getPharmaciesFilter('filterStatus');
        },

        set(val) {

            // save new values in our store
            this.$store.commit('setPharmaciesFilter', { type: 'filterStatus', value: val });

            // emit new values to our table component
            Event.$emit('vue-tables.tblPharmacies.filter::filterCatalog', {
                filterStatus: val,
                filterMutation: this.filterMutation
            });

        }

    },

    filterChangedPharmacies: {

        get() {
            return this.$store.getters.getPharmaciesFilter('filterChangedPharmacies') == null ? false : this.$store.getters.getPharmaciesFilter('filterChangedPharmacies');
        },

        set(val) {

            this.$store.commit('setPharmaciesFilter', { type: 'filterChangedPharmacies', value: val });
            Event.$emit('vue-tables.tblPharmacies.filter::changedPharmacies', val );
        }
    }

	},

    watch: {

        filterStatusChanged() {

            // if computed property filterStatusChanged() changes,
            // we correspondingly set the isFilterActive to true or false
            this.isFilterActive = !this.filterStatusChanged;

            if(!this.isFilterActive) {
                this.resetFilter();
            }
        },

    },

	methods: {

    reminder(type, count) {

        this.showModal = true;
        this.modal.title = this.$t("SITE-MODAL_TITLE-"+type.toUpperCase());
        this.modal.width = 520;
        this.modal.txtSubmit = "absenden";
        this.modal.txtCancel = "abbrechen";
        this.modal.type = type;
        this.modal.count = count;

    },

    reminderSend() {

        this.modal.isSending = true;

        let url = this.$config.api + 'site/'+this.modal.type;
        var self = this;

        this.axios.get(url)
            .then(response => {

                var taskLogId = response.data.taskLogId;

                self.refreshIntervalId = setInterval(function() {

                    self.axios.get(self.$config.api + 'taskLog/' + taskLogId)
                        .then(function(response) {

                            self.progressStatus = response.data;

                            if(['Finished', 'Error'].indexOf(response.data.status) > -1) {
                                clearInterval(self.refreshIntervalId);
                                self.modal.isSending = false;
                            }

                        });

                }.bind(self), 800);

            });

    },

    closeModal() {

        clearInterval(this.refreshIntervalId);
        this.progressStatus = null;
        this.refreshIntervalId = null;
        this.showModal = false;
        this.modal.isSending = false;
        this.modal.class = null;
        this.isCustomizationPreview = false;
        this.activePage = null;

    },

    goHistory() {
        this.$router.push({name: 'apoHistory' });
    },

    getsiteCatalogStatusNameById(id) {

        var res = "";

        Object.keys(this.siteCatalogStatus).forEach(key => {
            if(this.siteCatalogStatus[key].id == id) {
                res = this.siteCatalogStatus[key].name;
            }
        });

        return res;

    },

    resetFilter() {

        // set all filter vars to their initial state
        this.searchString = null;
        this.filterStatus = null;
        this.filterMutation = null;
        this.filterChangedPharmacies = false;

    },

    getPackage(row) {

        if(row.package && row.package != null) {

            var mutation = " - ";

            // get language string for packge id
            switch(parseInt(row.package)) {
                case 1:
                    mutation = "Paket 1";
                    break;
                case 2:
                    mutation = "Paket 2";
                    break;
                case 3:
                    mutation = "Paket 3";
                    break;
                default:
                    mutation = row.package;
            }


            // check if there are any voucherPackages
            if(row.voucherPackage) {

                // voucher package 3
                if(row.voucherPackage == this.voucherPackages.VOUCHERS_3.id) {
                    mutation += " + GS";
                }

                // voucher package 6
                else if(row.voucherPackage == this.voucherPackages.VOUCHERS_6.id) {
                    mutation += " + GS(6)";
                }

                else {
                    mutation += "";
                }

            }

            return mutation;


        } else {

            return "";

        }

    },

    customizationPreviews(row) {

        var res = "";
        if(row.customizationPreviews) {

            for (var property in row.customizationPreviews) {
                if (row.customizationPreviews.hasOwnProperty(property)) {
                    let iconClass = "icon-ak-check-";
                    iconClass += row.customizationPreviews[property] != null ? 'active' : 'empty';
                    res += '<span class="icon is-small"><i class="'+iconClass+'"></i></span>';
                }
            }

            /*
            for(let i =0; i < parseInt(row.package); i++) {

                let iconClass = "icon-ak-check-";
                if(i==0 && row.customizationPreviews.U1_U4 != null ||
                    i==1 && row.customizationPreviews.U2 != null ||
                    i==2 && row.customizationPreviews.US != null) {
                    iconClass += 'active';
                } else {
                    iconClass += 'empty';
                }

                res += '<span class="icon is-small"><i class="'+iconClass+'"></i></span>';

            }
            */

        }

        return res;
    },

    showCustomizationPreviews(row) {

        this.isCustomizationPreview = true;
        this.activePage = row;
        this.modal.title = row.site.name + ' (#'+row.site.extRef+')';
        this.modal.txtCancel = "schließen";
        this.modal.type = null;
        this.modal.class = "fullPage";
        this.showModal = true;

    },

    loadCustomizationImage(img) {

        console.log("img: ", img);
        return this.$config.assets + img;

    },

    doExport(type) {

			this.generatedDownloadLink = "";
			let self = this;
			let urlPart = "";

      switch(type) {
        case "pharmacies":
          urlPart = "site/exportList?output=xlsx&link=1&filename=apotheken"; break;
        case "catalog":
          urlPart = "siteCatalog/exportList?output=xlsx&link=1&filename=katalog"; break;
        case "orders":
          urlPart = ""; break;
        case "mutations":
          urlPart = ""; break;
        default: urlPart = "";
      }

			this.axios.get(this.$config.api + urlPart)
				.then(function(response) {
					self.generatedDownloadLink = response.data.url;
				}).catch(function(error) {
					self.modalErrorMsg = "Beim Erstellen des Downloadlinks trat ein Fehler auf: " + error;
					console.log(error);
				});

      this.showModal = true;

    },

		downloadFile: function() {

			document.getElementById('downloadIframe').src = this.$config.cdnHost + this.generatedDownloadLink;
			this.showModal = false

		},

		fetchData() {

			this.isLoading = true;
			var self = this;

			// get apoData
			function getApos() {
				// return self.axios.get(self.$config.api + 'siteCatalog?include=siteCatalog.site,siteCatalog.siteCatalogCustomizations,site.contactPerson,siteCatalog.catalog&filters[catalog]='+self.catalogId);
        return self.axios.get(self.$config.api + 'siteCatalog/liteList?catalog='+self.catalogId);
			}

			// get stats
			function getStats() {
				return self.axios.get(self.$config.api + 'siteCatalog/'+self.catalogId+'/stats');
			}

      // get reminder status
      function reminderStatus() {
          return self.axios.get(self.$config.api + 'site/reminderStatus');
      }

			// make the request
			this.axios.all([getApos(), getStats(), reminderStatus()])

				.then(self.axios.spread(function (apos, stats, reminderStatus) {

					self.table.tblData = apos.data.siteCatalog;
          self.reminderStatus = reminderStatus.data;

					if(stats.data.stats) {

						Object.keys(stats.data.stats).forEach(function(key) {
							// round percentage
							stats.data.stats[key]['percentage'] = Math.round(stats.data.stats[key]['percentage'] * 10) / 10;
							// format number
							stats.data.stats[key]['value'] = stats.data.stats[key]['value'].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
						});
						self.stats = stats.data.stats;

					}

					self.isLoading = false;

				})).catch(function(error) {

					self.isLoading = false;

				});

		},

	}

}
</script>



<style>
  .buttonDropzone .dropzone {
      min-height: 80px !important;
      border: none !important;
      border-radius: 3px;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      align-items: center;
      background: #475465 !important;
      transition: all .3s ease;
      cursor: pointer;
  }
  .buttonDropzone .dropzone:hover {
      background: #353e4b !important;
  }
  .buttonDropzone .dropzone .dz-message {
      display: none !important;
  }
  .buttonDropzone .dropzone::after {
      content: "Erfolgskontrolle hochladen";
      display: block;
      width: 100%;
      height: 100%;
      text-align: center;
      text-transform: uppercase;
      color: #eee;
      font-size: 12px;
      border-radius: 3px;
  }
  .buttonDropzone .dropzone .dz-preview {
      height: 50px;
      min-height: 50px;
      margin: 0;
      display: none;
  }
  .buttonDropzone .vue-dropzone .dz-preview .dz-error-mark,
  .buttonDropzone .vue-dropzone .dz-preview .dz-success-mark {
      margin-left: auto!important;
      margin-top: auto!important;
      width: 100% !important;
      left: 0;
      top: 0 !important;
  }

  .buttonDropzone .vue-dropzone .dz-preview .dz-error-mark i {
      font-size: 100%;
  }
  .buttonDropzone .dz-default.dz-message i {
      font-size: 2rem;
  }
</style>


<style scoped>

  .showChangesButton .button .icon {
      display: inline-block;
      height: 20px !important;
      line-height: 22px !important;
      width: 24px;
      font-size: 16px !important;
  }

  .customizations li { float: left; list-style: none; margin-left: 2px; border: 1px solid #999; padding: 1px; font-size: 8px; color: #999; }
  .customizations li.approved { border: 1px solid limegreen; background: limegreen; color: #fff; }
  .customizations li.print-approved { border: 1px solid darkgreen; background: darkgreen; color: #fff; }

  .kpi { background-color: #fff; padding: 10px 15px; margin-bottom: 10px; border-radius: 3px; }
  .kpi .item { text-align: right; }
  .kpi .item .label { font-weight: normal; text-align: left; display: inline-block; font-size: .85rem; margin-bottom: 0; }
  .kpi .item .separator { border-right: 1px solid pink; }
  .kpi .item .value { font-weight: bold; }
  .kpi .item .percentage { font-size: 10px; }
  .kpi .item .percentage.green { color: green; }
  .kpi .item .percentage.red { color: red; }
  .kpi .item span:last-child {
  	display: inline-block;
  	text-align: right;
  }

  .tblPharmacies >>> .pages + .pages:before {
  	content: ",";
  }
  .tblPharmacies >>> tbody > tr > td:first-child {
  	position: relative;
  }
  .tblPharmacies >>> table .status > td:first-child:after {
  	background: transparent;
      content: "";
      position: absolute;
      left: 0;
      top: 0;
  	bottom: 0;
  	height: 100%;
      width: 5px;
  }

  .tblPharmacies >>> table tr td {
      padding-top: 18px;
      padding-bottom: 18px;
  }

  .tblPharmacies >>> th:first-child {
      width: 75px;
  }
</style>


<style lang="scss" scoped>

  @import '../../assets/css/variables.scss';

  table .status > td:first-child::after {
		background: transparent;
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    height: 100%;
    width: 5px;
	}
	.tblPharmacies table .status.NONE > td:first-child::after {
		background-color: $statusCreated;
	}
  .tblPharmacies table .status.APPROVAL_REQUESTED > td:first-child::after {
    background: $statusApprovalRequested !important;
  }
  .tblPharmacies table .status.APPROVED > td:first-child::after {
    background: $statusSiteApproved !important;
  }
  .tblPharmacies table .status.COORDINATION > td:first-child::after {
    background: $statusReview !important;
  }
  .tblPharmacies table .status.READY > td:first-child::after {
    background: $statusEdited !important;
  }
  .tblPharmacies table .status.LAYOUTED > td:first-child::after {
	   background: $statusLayouted !important;
  }
  .tblPharmacies table .status.PRINT_APPROVAL_REQUESTED > td:first-child::after {
    background: $statusPrintApprovalRequested !important;
  }
  .tblPharmacies table .status.PRINT_APPROVED > td:first-child::after {
    background: $statusRevised !important;
  }
  .tblPharmacies table .status.PRINT_READY > td:first-child::after {
    background: $statusPrintApproved !important;
  }
</style>

<style>
.customizationPreview .icon-ak-check-empty {
    color: #ddd !important;
}
/*
.customizationPreview .icon-ak-check-active {
    color: green !important;
}
*/
.modal.fullPage {
    align-items: center !important;
}
.modal.fullPage .modal-card {
    height: 95vh;
    width: 95vw !important;
    margin: 0 !important;
}
.modal.fullPage .modal-card-body {
    overflow: auto;
    overflow-y: visible;
}

.previewWrappers {
    display: flex;
    justify-content: space-around;
    align-items: center;
    position: absolute;
    top: 54px;
    bottom: 63px;
    left: 0;
    right: 0;
}
.previewWrappers .previewWrapper {
    position: relative;
    border: 1px solid #f1f1f1;
    height: 16vw;
    width: 16vw;
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    margin: 0 20px;
}
.previewWrappers .previewWrapper .title {
    position: absolute;
    left: 0;
    top: -30px;
    font-size: 16px;
    font-weight: bold;
}

.previewWrappers .previewWrapper.U1_U4,
.previewWrappers .previewWrapper.US {
    width: 32vw;
}
.previewWrappers .previewWrapper.U2 {

}

.previewWrappers .previewWrapper[lazy=loading] {
    background-position: 50% 50% !important;
    background-size: 30% !important;
}

.previewWrappers .previewWrapper[lazy=error] {
    background: transparent url('../../assets/img/bg-preview_customization.jpg') center no-repeat !important;
    background-size: 100% !important;
}
</style>
